import React from 'react'
import { Icon } from 'antd'
import * as styles from './index.scss'

interface Props {
  id: number
  cover: string
  name: string
  region: string
  desc: string
  small?: boolean
  onClick: React.EventHandler<any>
}

const Year: React.SFC<Props> = ({
  id,
  cover,
  name,
  region,
  desc,
  small,
  onClick,
}) => {
  const cls = (t, s = '') => (small ? `${t}Sm${s}` : `${t}${s}`)
  return (
    <div className={styles[cls('year')]}>
      <div className={styles[cls('year', 'Cover')]}>
        <div
          style={{
            backgroundImage: `url(${cover})`,
            backgroundPosition: 'top center',
            backgroundSize: '100%',
          }}
        />
      </div>
      <div className={styles[cls('year', 'Inner')]}>
        <div className={styles[cls('year', 'InnerName')]}>{name}</div>
        <div className={styles[cls('year', 'InnerDesc')]}>{`${region}`}</div>
        <div className={styles[cls('year', 'InnerDesc')]} title={desc}>
          {desc}
        </div>
      </div>
      <div
        className={styles[cls('year', 'Btn')]}
        style={{
          opacity: !id && 0.5,
          cursor: !id && 'no-drop',
        }}
        onClick={id && onClick}
      >
        成长故事
        <Icon type="right" />
      </div>
    </div>
  )
}

export default Year
